import { render, staticRenderFns } from "./NotificationsPreview.vue?vue&type=template&id=40cd9f69&"
import script from "./NotificationsPreview.vue?vue&type=script&lang=js&"
export * from "./NotificationsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports